
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightAolColourOn as ObiLightAolColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-aol-colour-on.js';
 
 
 

 
 export const ObiLightAolColourOn = createComponent({
   react: React,
   tagName: 'obi-light-aol-colour-on',
   elementClass: ObiLightAolColourOnElement,
   events: {
     
   }
  });
 
 